import React from 'react';
import {BrowserRouter } from 'react-router-dom';
import Router from './component/routes';

function App() {
  
  return <>

<BrowserRouter basename={'/digital-heroes'}>
<Router />
</BrowserRouter>
  </>
}

export default App;
 